// TODO: Ask Kevin to fill this up

import { strEnum } from "../../types";

export const TIME_RANGE_MEASURES = strEnum<string>([
    "TIME_MINS",
    "TIME_HOUR",
    "TIME_HOURS",
    "TIME_DAYS"
]);
export type TIME_RANGE_MEASURES = keyof typeof TIME_RANGE_MEASURES;

export const LOG_LEVEL_IDS = strEnum<string>([
    "INFO",
    "DEBUG",
    "WARN",
    "ERROR",
    "N/A"
]);
export type LOG_LEVEL_IDS = keyof typeof LOG_LEVEL_IDS;

export const TIME_RANGE_IDS = strEnum<string>([
    "5m",
    "30m",
    "1h",
    "12h",
    "24h",
    "7d",
    "30d",
    "custom"
]);
export type TIME_RANGE_IDS = keyof typeof TIME_RANGE_IDS;

export const QUERY_STYLES = strEnum<string>([
    "history",
    "tail"
]);
export type QUERY_STYLES = keyof typeof QUERY_STYLES;

export const QUERY_REQUEST_ORDER = strEnum<string>([
    "DESC",
    "ASC"
]);
export type QUERY_REQUEST_ORDER = keyof typeof QUERY_REQUEST_ORDER;

export interface IUnityProxyTimeRange {
    id: TIME_RANGE_IDS;
    label: string;
    /**
     * Time in milliseconds
     */
    value: number;
    measure: TIME_RANGE_MEASURES;
}

export interface IUnityProxyLogLevel {
    id: LOG_LEVEL_IDS;
    label: string;
    value: boolean;
    status: string;
}

export interface IUnityProxyLogEntry {
    id: string;
    /**
     * Time in milliseconds
     */
    time: number;
    logLevelId: LOG_LEVEL_IDS;
    message: string;
}

export interface IUnityProxyResponse {
    code: string;
    message: string;
}

// tslint:disable-next-line: no-empty-interface
export interface IUnityProxyQueryRequest {
    appId: string;
    timeSlot?: TIME_RANGE_IDS;
    startTime?: string;
    endTime?: string;
    clientTimeZone?: string;
    columns?: string[];
    appInstances?: string[];
    limitMaximumRows?: number;
    autoExpire?: boolean;
}

export interface IUnityProxyLogsQueryRequest extends IUnityProxyQueryRequest {
    style: QUERY_STYLES;
    logLevels?: LOG_LEVEL_IDS[];
    logOrder?: QUERY_REQUEST_ORDER;
    messageTransform?: string;
    sysBodyIndex?: string;
}

export interface IUnityProxyStatsQueryRequest extends IUnityProxyQueryRequest {
    statsOrder?: QUERY_REQUEST_ORDER;
    fetchRawData?: boolean;
}

export interface IUnityProxyQueryResponse extends IUnityProxyResponse {
    content: {
        queryId: string;
        columns: IUnityProxyQueryResponseColumn[]
    };
}

export interface IUnityProxyQueryResponseColumn {
    name: string;
    type: string;
    clickable: boolean;
    hasStats: boolean;
}

export interface IUnityProxyFetchRequest {
    queryId: string;
    style: QUERY_STYLES;
    startRow?: number;
    fetchSize?: number;
}

// tslint:disable-next-line: no-empty-interface
// tslint:disable-next-line: no-empty-interface
export interface IUnityProxyFetchTailResponse extends IUnityProxyResponse {
    content: IUnityProxyFetchTailContent;
}

export interface IUnityProxyFetchHistoricalResponse extends IUnityProxyResponse {
    content: IUnityProxyFetchHistoricalContent;
}

export interface IUnityProxyFetchTailContent {
    eventsToProcess: number;
    /**
     * This is a string of the boolean value, either "true" or "false".
     */
    finished: string;
    queryProgress: number;
    results: string[][];
}

export interface IUnityProxyFetchHistoricalContent {
    totalCount: number;
    messages: {
        severity: string;
        text: string;
    }[];
    finished: string;
    queryTime: number;
    results: string[][];
}

// tslint:disable:no-empty-interface
export interface IUnityProxyDeleteResponse extends IUnityProxyResponse {
    /**
     * No extensions yet
     */
}
